import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("splash_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Separate client for the vetted-lead (OTP) flow — uses its own token, no user cookie.
export const leadApi = axios.create({ baseURL: API, withCredentials: false });

leadApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("splash_lead_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function sanitizeEmbed(html) {
  if (!html) return html;
  return html
    .replace(/muted=true/gi, "muted=false")
    .replace(/([?&])muted=1\b/gi, "$1muted=0")
    .replace(/\smuted(=("|')(true|muted)("|'))?(?=[\s/>])/gi, " ");
}
